var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheatersBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3921_1124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 2.5V4.16667H13.3333V2.5H6.66659V4.16667H4.99992V2.5H3.33325V17.5H4.99992V15.8333H6.66659V17.5H13.3333V15.8333H14.9999V17.5H16.6666V2.5H14.9999ZM6.66659 14.1667H4.99992V12.5H6.66659V14.1667ZM6.66659 10.8333H4.99992V9.16667H6.66659V10.8333ZM6.66659 7.5H4.99992V5.83333H6.66659V7.5ZM11.6666 15.8333H8.33325V4.16667H11.6666V15.8333ZM14.9999 14.1667H13.3333V12.5H14.9999V14.1667ZM14.9999 10.8333H13.3333V9.16667H14.9999V10.8333ZM14.9999 7.5H13.3333V5.83333H14.9999V7.5Z",
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3921_1124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheatersBlack);
export default __webpack_public_path__ + "static/media/theaters_black.d1767e7b5bb92f50d341bf0556c1aab2.svg";
export { ForwardRef as ReactComponent };